import { centerCrop, makeAspectCrop } from 'react-image-crop';
export var setCropPosition = function (width, height) {
    var aspect = 1;
    return centerCrop(makeAspectCrop({
        unit: '%',
        width: 90,
        height: 90,
    }, aspect, width, height), width, height);
};
export var canvasPreview = function (image, canvas, crop) {
    var ctx = canvas.getContext('2d');
    if (!ctx) {
        throw new Error('No 2d context');
    }
    var scaleX = image.naturalWidth / image.width;
    var scaleY = image.naturalHeight / image.height;
    var pixelRatio = window.devicePixelRatio;
    canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
    canvas.height = Math.floor(crop.height * scaleY * pixelRatio);
    ctx.scale(pixelRatio, pixelRatio);
    ctx.imageSmoothingQuality = 'high';
    var cropX = crop.x * scaleX;
    var cropY = crop.y * scaleY;
    var centerX = image.naturalWidth / 2;
    var centerY = image.naturalHeight / 2;
    ctx.save();
    ctx.translate(-cropX, -cropY);
    ctx.translate(centerX, centerY);
    ctx.translate(-centerX, -centerY);
    ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, 0, 0, image.naturalWidth, image.naturalHeight);
    ctx.restore();
};
